export default "__VITE_ASSET__CclnQ$Q8__";